import { Injectable } from '@angular/core';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { Actions, concatLatestFrom, createEffect, ofType } from '@ngrx/effects';
import { debounce, interval, tap } from 'rxjs';
import { togglePrintMode } from '@brain-portal/store/ui.action';
import { State } from '../../reducers';
import { Store } from '@ngrx/store';
import { selectPrintMode } from '@brain-portal/store/ui.selector';

@Injectable()
export class UIEffects {
  printEffect$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(togglePrintMode),
        concatLatestFrom(() => [this.store.select(selectPrintMode)]),
        debounce(() => interval(1000)),
        tap(([, printMode]) => {
          if (printMode) {
            this.announceOnPrintComplete();
            window.print();
          }
        }),
      );
    },
    { dispatch: false },
  );

  constructor(
    private actions$: Actions,
    private store: Store<State>,
    private liveAnnouncer: LiveAnnouncer,
  ) {}

  /** Still-pending listener from a previous announceOnPrintComplete() call, if `afterprint` has not
   *  fired for it yet -- see below. */
  private printCompleteListener?: () => void;

  private announceOnPrintComplete(): void {
    if (this.printCompleteListener) {
      window.removeEventListener('afterprint', this.printCompleteListener);
    }
    this.printCompleteListener = (): void => {
      this.printCompleteListener = undefined;
      void this.liveAnnouncer.announce('Export complete.', 'polite');
    };
    window.addEventListener('afterprint', this.printCompleteListener, { once: true });
  }
}
